import React from 'react';
import Offer from '../Offer/Offer';
import AnnualBoilerServiceImage from '@/src/resources/annual-boiler-service-2026.png';
import { Heading2, Margin, P } from '@ovotech/nebula';
import { UnorderedListSection } from '../../UnorderedListSection';

export const FreeEssentials = () => {
  return (
    <Offer
      offerId="homeplan-free-essentials"
      image={AnnualBoilerServiceImage}
      linkUrl="https://homeservices.ovoenergy.com/essentials/?promoCode=ESSMYOVO"
      linkText="Claim Offer"
      lowerBody={<P>Terms and eligibility apply</P>}
    >
      <Heading2> Free Essentials Boiler Cover worth £168</Heading2>
      <Margin bottom={4}>
        <UnorderedListSection
          title=""
          list={[
            'Annual boiler service included',
            'Unlimited call-outs',
            '24/7 emergency helpline',
          ]}
        />
      </Margin>
    </Offer>
  );
};
